<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-6">
        <list-subject-types
          class="w-100"
          autocomplete
          label="Distribución"
          name="copySubjectType"
          v-model="copySubjectForm.copySubjectType"
          v-validate="'required'"
          :danger="errors.has('inputDoc.copySubjectType')"
          :danger-text="errors.first('inputDoc.copySubjectType')"
          ref="copySubjectType"
          :isClearable="false"
        />
      </div>
      <div class="col-md-6" v-if="copySubjectForm.copySubjectType === 'docDigital'">
        <list-institutions-doc-digital
            class="w-100"
            autocomplete
            :isClearable="false"
            label="Lista de Instituciones DocDigital"
            name="copySubjectTypeDigitalDoc"
            v-model="copySubjectForm.copySubjectTypeDigitalDoc"
            :parent-value="copySubjectForm.copySubject"
            v-validate="{ required: copySubjectForm.copySubjectType === 'docDigital'}"
            :danger="errors.has('inputDoc.copySubjectTypeDigitalDoc')"
            :danger-text="errors.first('inputDoc.copySubjectTypeDigitalDoc')"
            ref="copySubjectTypeDigitalDoc"
            @full-input="setSubject"
        />
      </div>
      <div :class="{
        'col-12': copySubjectForm.copySubjectType === 'docDigital',
        'col-md-6': copySubjectForm.copySubjectType !== 'docDigital',
      }">
        <list-offices
          v-if="
              !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType === 'oficinas'
            "
          class="w-100"
          autocomplete
          label="Oficina"
          name="copySubject"
          v-model="copySubjectForm.copySubject"
          :danger="errors.has('inputDoc.copySubject')"
          :danger-text="errors.first('inputDoc.copySubject')"
          v-validate="{ required:  !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType === 'oficinas' }"
          ref="copySubject"
          key="copy-subject-select"
        />
        <list-groups
          v-if="
              !isInput.includes(copySubjectForm.copySubjectType)
                && (copySubjectForm.copySubjectType === 'unidades'
                || copySubjectForm.copySubjectType === 'comisiones')
            "
          class="w-100"
          autocomplete
          :label="copySubjectForm.copySubjectType === 'unidades' ? 'Unidad' : 'Comisión'"
          :showOnlyCommissions="copySubjectForm.copySubjectType === 'comisiones'"
          :showOnlyUnits="copySubjectForm.copySubjectType === 'unidades'"
          name="copySubject"
          :typeList="1"
          v-model="copySubjectForm.copySubject"
          :danger="errors.has('inputDoc.copySubject')"
          :danger-text="errors.first('inputDoc.copySubject')"
          v-validate="{ required:  !isInput.includes(copySubjectForm.copySubjectType)
            && (copySubjectForm.copySubjectType === 'unidades'
            || copySubjectForm.copySubjectType === 'comisiones') }"
          ref="copySubject"
          key="copy-subject-select"
        />
        <list-subjects
          v-if="
              !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType !== 'usuarios'
                && copySubjectForm.copySubjectType !== 'oficinas'
                && copySubjectForm.copySubjectType !== 'unidades'
                && copySubjectForm.copySubjectType !== 'comisiones'
            "
          class="w-100"
          autocomplete
          :isClearable="false"
          label="Lista de Distribución"
          name="copySubject"
          v-model="copySubjectForm.copySubject"
          :parent-value="copySubjectForm.copySubjectType"
          v-validate="{
              required: !isInput.includes(copySubjectForm.copySubject)
                && copySubjectForm.copySubjectType !== 'usuarios'
            }"
          :danger="errors.has('inputDoc.copySubject')"
          :danger-text="errors.first('inputDoc.copySubject')"
          :disabled="!copySubjectForm.copySubjectType || this.institutionsDocDigitalState.loading"
          ref="copySubject"
          key="copy-subject-select"
          @input="clearEntities"
        />
        <list-user
          v-if="
              !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType === 'usuarios'
            "
          class="w-100"
          autocomplete
          label="Lista de Destino"
          name="copySubject"
          v-model="copySubjectForm.copySubject"
          v-validate="{
              required: !isInput.includes(copySubjectForm.copySubjectType)
                && copySubjectForm.copySubjectType === 'usuarios'
            }"
          withFilters
          :disabled="!copySubjectForm.copySubjectType"
          :danger="errors.has('inputDoc.copySubject')"
          :danger-text="errors.first('inputDoc.copySubject')"
          ref="copySubject"
          key="copy-subject-select"
        />
        <vs-input
          v-if="isInput.includes(copySubjectForm.copySubjectType)"
          class="w-100"
          label="Ingrese un nombre"
          name="copySubject"
          v-model="copySubjectForm.copySubject"
          v-validate="{ required: isInput.includes(copySubjectForm.copySubjectType) }"
          :danger="errors.has('inputDoc.copySubject')"
          :danger-text="errors.first('inputDoc.copySubject')"
          key="copy-subject-input"
        />
      </div>
    </div>
    <div class="row mb-3" v-if="emailRequired.includes(copySubjectForm.copySubjectType)">
      <div class="col-12">
        <vs-input
          class="w-100"
          label="Correo Electrónico Persona Destinatario"
          name="copySubjectEmail"
          v-model="copySubjectForm.copySubjectEmail"
          v-validate="{
              required: emailRequired.includes(copySubjectForm.copySubjectType)
              ,
              email: true
            }"
          :danger="errors.has('inputDoc.copySubjectEmail')"
          :danger-text="errors.first('inputDoc.copySubjectEmail')"
        />
      </div>
    </div>
    <div class="row mb-3" v-if="copySubjectForm.copySubjectType === 'usuarios'">
      <div class="col-6">
        <label>Fecha Vencimiento</label>
        <b-form-datepicker
          locale="es"
          :min="minDate"
          placeholder="Fecha vencimiento"
          name="providenceExpiration"
          v-model="copySubjectForm.providenceExpiration"
          label-help="Puede usar las flechas del teclado y espacio"
        />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12 d-flex align-items-end justify-content-end">
        <b-button
          data-cy="add-copy-button"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          v-on:click="addCopy()"
        >
          Agregar copia a
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>

import Ripple from 'vue-ripple-directive';
import { mapGetters } from 'vuex';

import ListSubjects from '@/febos/chile/lists/components/ListSubjects';
import ListInstitutionsDocDigital from '@/febos/chile/lists/components/ListInstitutionsDocDigital';
import ListSubjectTypes from '@/febos/chile/lists/components/ListSubjectTypes';
import ListUser from '@/febos/chile/lists/components/ListUser';
import ListOffices from '@/febos/chile/lists/components/ListOffices';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ProvidencesTypes from '@/febos/chile/dnt/mixins/ProvidencesTypes';

export default {
  components: {
    ListSubjects,
    ListSubjectTypes,
    ListInstitutionsDocDigital,
    ListUser,
    ListOffices,
    ListGroups
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      minDate: this.$moment().format('YYYY-MM-DD'),
      commentary: '',
      emailRequired: ['personas', 'empresas', 'ministerios', 'personasJuridicas', 'organismoEstado'],
      isInput: ['personas', 'empresas', 'personasJuridicas', 'organismoEstado'],
      subjectForm: {
        subjectType: '',
        providence: '',
        providenceExpiration: '',
        subject: '',
        subjectTypeDigitalDoc: '',
        subjectEmail: '',
      },
      copySubjectForm: {
        copySubjectType: '',
        providence: ProvidencesTypes.KNOWLEDGE,
        providenceExpiration: '',
        copySubject: '',
        copySubjectTypeDigitalDoc: '',
        copySubjectEmail: '',
      },
      subjectsSelected: []
    };
  },
  computed: {
    ...mapGetters('Dnts', [
      'participants'
    ]),
    ...mapGetters('List', [
      'institutionsDocDigitalState'
    ]),
  },
  props: {},
  methods: {
    clearEntities() {
      if (this.copySubjectForm.copySubjectTypeDigitalDoc) {
        this.copySubjectForm.copySubjectTypeDigitalDoc = '';
      }
    },
    setSubject(event) {
      this.copySubjectForm.copySubject = event?.order.toString() || '';
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async addCopy() {
      const isValid = await this.validateForm('inputDoc');

      if (!isValid) {
        return;
      }

      const copySubjectType = this.$refs.copySubjectType.getOption();
      const copySubject = this.isInput.includes(this.copySubjectForm.copySubjectType)
        ? {
          label: this.copySubjectForm.copySubject,
          value: this.copySubjectForm.copySubject,
          id: this.copySubjectForm.copySubject
        }
        : this.$refs.copySubject.getOption();

      const copySubjectTypeDigitalDoc = this.$refs.copySubjectTypeDigitalDoc
        ? this.$refs.copySubjectTypeDigitalDoc.getOption()
        : {};

      const row = {
        copySubjectType,
        copySubject,
        copySubjectTypeDigitalDoc,
        copySubjectEmail: this.copySubjectForm.copySubjectEmail,
        providence: this.copySubjectForm.providence,
        providenceExpiration: this.copySubjectForm.providenceExpiration
      };
      this.$emit('add-copy', row);
      this.copySubjectForm.copySubject = '';
      this.copySubjectForm.providence = 1;
      this.copySubjectForm.providenceExpiration = '';
      this.copySubjectForm.copySubjectTypeDigitalDoc = '';
      this.copySubjectForm.copySubjectEmail = '';
      await this.$validator.reset();
    }
  }
};
</script>
<style>

</style>
